import React from 'react';
import FileUtil from './FileUtil/FileUtil';
import dataModel from '../models/DataModel';
import cloudDownload from '../assets/images/cloud-download.svg';
import Download from '../components/Download';
import VideoPlayer from '../components/VideoPlayer';

function repositionElement(element) {
  if (element) {
    const parentElement = element.parentElement.parentElement;
    parentElement.appendChild(element);
  }
}
function getConvertedDocumentView(attachment) {
  const extension = FileUtil.getExtension(attachment.name);
  if (extension == 'pdf' && !dataModel.mobileBridge.isMobile) {
    let attachmentData = null;
    if (attachment.attachment) {
      attachmentData = attachment.attachment;
    }
    else if (attachment.expiring_url) {
      attachmentData = attachment.expiring_url;
    }
    else if (attachment.upload) {
      if (attachment.upload && (attachment.upload instanceof Blob)) {
        attachmentData = URL.createObjectURL(attachment.upload);
      }
      else {
        attachmentData = attachment.upload;
      }
    }
    return <object type="application/pdf" id='embed' key={'pdf-embed-' + attachment.id} className="display-pdf misc-filled-image-display" data={ attachmentData }/>;
  }
  else if (attachment.conversions && attachment.conversions.length && !(typeof attachment.conversions[0] == 'number')) {
    const scroller = attachment.conversions.map((conversion, i) => {
      return <img key={'conversion-' + conversion.id} className="display-conversion-image" src={conversion.upload} alt={attachment.name+'-page-'+i}/>;
    });
    let content = <img className="request-download-image" alt="download-document" src={cloudDownload}
      style={{
        width: 32,
        height: 32,
        padding: 8,
        backgroundColor: 'rgba(0, 0, 0, 0.51)',
      }} />;

    const download = <Download download={attachment.name} href={attachment.upload ? attachment.upload : attachment.attachment} content={content}/>;
    
    return <div className="display-conversion-images">
      <div className="request-download-image-container" ref={element => {repositionElement(element);}}
        style={{
          position: 'absolute',
          top: 0,
          right: 0,
          width: 48,
          height: 48,
          cursor: 'pointer', 
        }}>
        {download}
      </div>
      {scroller}
    </div>;
  }
  else {
    let attachmentData = null;
    if (attachment.attachment) {
      attachmentData = attachment.attachment;
    }
    else if (attachment.expiring_url) {
      attachmentData = attachment.expiring_url;
    }
    else if (attachment.upload) {
      if (attachment.upload && (attachment.upload instanceof Blob)) {
        // NOTE: whatever createObjectURL doesn't work... causes an invalid URL display so reverted to previous thing which causes a preview not available display until the document uploads which is better (?)
        attachmentData = attachment.upload; //URL.createObjectURL(attachment.upload)
      }
      else {
        attachmentData = attachment.upload;
      }
    }
    if (attachment.upload_content_type && attachment.upload_content_type.startsWith('video')) {
      const type = attachment && attachment.upload_content_type ? attachment.upload_content_type : (attachment && attachment.upload && attachment.upload.type) ? attachment.upload.type : undefined;
      return (
        <VideoPlayer src={attachmentData} width={window.innerWidth - 20} height={328} type={type}/>
      );
    }
    else {
      return (
        <iframe 
          id="embed"
          key={'doc/xls-embed-' + attachment.id} 
          className="display-pdf misc-filled-image-display" 
          src={'https://docs.google.com/gview?url=' + encodeURIComponent(attachmentData) + '&embedded=true'} 
        />
      );
    }
  }
}

export default {
  getConvertedDocumentView,
};



// WEBPACK FOOTER //
// ./src/helpers/AttachmentHelper.js